import * as React from 'react';
import FactsOverview from './FactsOverview';
import * as reportDispatch from 'redux/ducks/reportData';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { ReportActions } from 'redux/ducks/reportFilter';
import { RootState } from 'redux/rootReducer';
import { ThunkDispatch } from 'redux-thunk';
import { getQuickOverviewFrequencyMetrics } from 'redux/ducks/reportData/selector';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type FactsOverviewContainerProps = DispatchProps & StateProps;

const foodWasteMetricsID = 'foodWasteMetricsOverview';
const regFrequencyMetricsID = 'regFrequencyMetrics';

const FactsOverviewContainer: React.FunctionComponent<FactsOverviewContainerProps> = (props) => {
  const { fetchData, foodWasteMetrics, regFrequencyMetrics, filter } = props;

  useEffect(() => {
    void fetchData(foodWasteMetricsID);
    void fetchData(regFrequencyMetricsID);
  }, [
    filter.basis,
    filter.dimension,
    filter.timeRange,
    filter.period,
    filter.filter,
    filter.selectedGuestTypeNames
  ]);

  return (
    <FactsOverview
      dimension={foodWasteMetrics.dimension}
      period={foodWasteMetrics.period}
      foodWasteMetrics={foodWasteMetrics}
      regFrequencyMetrics={regFrequencyMetrics}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  foodWasteMetrics: state.reportData[foodWasteMetricsID],
  regFrequencyMetrics: getQuickOverviewFrequencyMetrics(state),
  filter: state.reportFilter
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, void, ReportActions>) => ({
  fetchData: (identifier: reportDispatch.ReportDataIdentifier) =>
    dispatch(reportDispatch.fetchData(identifier))
});

export default connect<StateProps, DispatchProps, unknown>(
  mapStateToProps,
  mapDispatchToProps
)(FactsOverviewContainer);
